import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69fcba44"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = {
  key: 1,
  class: "skeleton-container flex"
}

import {useAppContext} from '@/logged/config';
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useAsideMenu} from '../aside-menu.store';
    import NavigationTabItem from './NavigationTabItem.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import {useDisplayMode} from '../stores';
    import {useUser} from '../../user';
    import {Skeleton} from '@/logged/common/ui';
    import {NavigationTab} from '..';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTabsContainer',
  setup(__props) {

    const {isDisplayMobile} = useDisplayMobile();
    const asideMenuStore = useAsideMenu();
    const appContext = useAppContext();
    const displayModeStore = useDisplayMode();
    const userStore = useUser();
    const {allNavigationRoutes, filteredNavigationRoutes} = storeToRefs(asideMenuStore);

    const renderedList = computed<NavigationTab[]>(() => {
        if (asideMenuStore.hydrateFromCache) {
            return filteredNavigationRoutes.value;
        } else {
            if (appContext.loading) {
                if (userStore.cachedIdentityRole) {
                    return allNavigationRoutes.value;
                }
                return [];
            }
            return filteredNavigationRoutes.value;
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navigation-tabs-container flex", {isReduced: _unref(displayModeStore).isDisplayModeReduced, isMobile: _unref(isDisplayMobile)}])
  }, [
    (_unref(renderedList).length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(renderedList), (tab) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: tab.id
          }, [
            (tab.ghostChildren?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  "data-test-id": tab.id,
                  class: "navigation-tab-container_ghosts flex"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.ghostChildren, (childTab) => {
                    return (_openBlock(), _createBlock(NavigationTabItem, {
                      key: childTab.id,
                      tab: childTab
                    }, null, 8, ["tab"]))
                  }), 128))
                ], 8, _hoisted_1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (tab.separator === 'top')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: `separator-${tab.id}`,
                        class: "separator flex"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(NavigationTabItem, { tab: tab }, null, 8, ["tab"]),
                  (tab.separator === 'bottom')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: `separator-${tab.id}`,
                        class: "separator flex"
                      }))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton)),
          _createVNode(_unref(Skeleton))
        ]))
  ], 2))
}
}

})